export default function Scoreboard({ score, handValue }) {
  return (
    <>
      <div id="scoreboard" aria-live="polite" aria-atomic="true">
        <span id="score-player">Você: {score.player}</span>
        <span className="score-separator">×</span>
        <span id="score-bot">Computador: {score.bot}</span>
      </div>
      <div id="hand-value-info">
        <span>Valor da mão: <strong id="hand-value">{handValue}</strong></span>
      </div>
    </>
  )
}
